import { render, staticRenderFns } from "./adv-list.vue?vue&type=template&id=739d65e4&scoped=true"
import script from "./adv-list.vue?vue&type=script&lang=js"
export * from "./adv-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739d65e4",
  null
  
)

export default component.exports